import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useCruiseRuntimeData(route: RouteLocationNormalizedLoaded) {
    const searchRequest = cruisesRuntimeStore.searchRequestFromQuery(route.query)
    if (cruisesRuntimeStore.departureCity?.id !== searchRequest.departureCityId) {
        await cruisesRuntimeStore.loadDepartureCity(searchRequest.departureCityId)
    } else if (
        searchRequest.departureCountryId &&
        cruisesRuntimeStore.departureCountry.id !== searchRequest.departureCountryId
    ) {
        await cruisesRuntimeStore.loadDepartureCountry(searchRequest.departureCountryId)
    }
    if (searchRequest.destinationCityId && cruisesRuntimeStore.destinationCity.id !== searchRequest.destinationCityId) {
        await cruisesRuntimeStore.loadDestinationCity(searchRequest.destinationCityId)
    } else if (
        searchRequest.destinationCountryId &&
        cruisesRuntimeStore.destinationCountry.id !== searchRequest.destinationCountryId
    ) {
        await cruisesRuntimeStore.loadDestinationCountry(searchRequest.destinationCountryId)
    }
}
